// Clients cannot publish to the server event bus; the server only exposes the SSE stream.
import type { StreamEvent } from '../../types';
import { apiClient } from '../api-client';

/**
 * Subscribe to real-time event stream via SSE
 * @param onMessage Callback for new StreamEvent
 * @param onError Optional error callback
 * @returns Cleanup function to close the SSE connection
 */
export const streamEvents = (
  onMessage: (event: StreamEvent) => void,
  onError?: (error: unknown) => void
): (() => void) => {
  let controller: AbortController | null = null;

  apiClient
    .streamEvents('/events/stream', {
      onmessage(event) {
        if (event.event && event.data) {
          try {
            onMessage({ type: event.event, data: JSON.parse(event.data) } as StreamEvent);
          } catch (err) {
            if (onError) {
              onError(err);
            }
          }
        }
      },
      onerror: onError,
      onclose: () => {
        throw new Error('SSE connection closed');
      },
    })
    .then((c) => {
      controller = c;
    });

  return () => {
    if (controller) {
      controller.abort();
    }
  };
};
